"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toasterLoading = void 0;

var _stylitas = require("@creditas/stylitas");

const rotation = (0, _stylitas.keyframes)`
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
`;

const toasterLoading = ({
  theme,
  variant
}) => (0, _stylitas.css)`
  align-items: center;
  display: flex;
  padding-left: 21px;
  padding-right: 21.5px;

  &:before {
    animation: ${rotation} 0.5s infinite linear;
    border: 1px solid ${theme[`bColor${variant}`]};
    margin-left: 13px;
    margin-right: 13px;
    border-left-color: ${theme.bColorneutral01};
    border-radius: 50%;
    content: '';
    height: 22px;
    opacity: 0;
    opacity: 1;
    transform: translateX(0);
    transition: opacity 0.3s ease, transform 0.1s 0.3s;
    width: 22px;
  }
`;

exports.toasterLoading = toasterLoading;